import io from "socket.io-client";

let Socket = null;
let Callbacks = null;

function setupEvents() {
  Socket.on("connect", () => {
    Socket.emit("join_queue");
  });

  Socket.on("new_order", (order) => {
    Callbacks.onNewOrder(order);
  });

  Socket.on("hide_order", (order_id, force) => {
    Callbacks.onHideOrder(order_id, force);
  });

  Socket.on("payment_request", (order_id, method) => {
    Callbacks.onPaymentRequest(order_id, method);
  });

  Socket.on("order_update", (order) => {
    Callbacks.onOrderUpdate(order);
  });

  Socket.on("joined", () => {
    Callbacks.onJoin();
  });
}

function init(_Callbacks) {
  if (Socket !== null && Socket.disconnect) {
    console.log("Disconnecting previous queue communicator...");
    Socket.disconnect();
  }

  if (window.location.hostname == "localhost") {
    Socket = io("http://localhost:3000/queue");
  } else {
    Socket = io("/queue");
  }

  Callbacks = _Callbacks;

  setupEvents();
  setTimeout(() => {
    Callbacks.onJoin();
  }, 500);
}

export default {
  init,
};
